export const ONE_TRUST_GROUPS = {
  STRICTLY_NECESSARY: 'C0001',
  ANALYTICS: 'C0002',
  FUNCTIONAL: 'C0003',
  TARGETING: 'C0004',
} as const;

export const ONETRUST_CONSENT_CHANGED_EVENT = 'onetrust-consent-changed';

export function hasUserMadeConsentChoice(): boolean {
  return document.cookie.includes('OptanonAlertBoxClosed=');
}

/**
 * OneTrust sets OnetrustActiveGroups to default/opt-in categories before the user
 * confirms. The OptanonConsent cookie groups= param is the real source of truth
 * after the banner has been dismissed.
 */
function getConsentedGroupsFromCookie(): Set<string> {
  if (!hasUserMadeConsentChoice()) return new Set();

  const match = document.cookie.match(/(?:^|;\s*)OptanonConsent=([^;]*)/);
  if (!match) return new Set();

  try {
    const value = decodeURIComponent(match[1]);
    const groupsMatch = value.match(/groups=([^&]*)/);
    if (!groupsMatch) return new Set();

    const consented = new Set<string>();
    groupsMatch[1].split(',').forEach((entry) => {
      const [id, status] = entry.split(':');
      if (id && status === '1') consented.add(id.trim());
    });
    return consented;
  } catch {
    return new Set();
  }
}

export function hasConsent(category: string): boolean {
  if (!hasUserMadeConsentChoice()) return false;
  return getConsentedGroupsFromCookie().has(category);
}

export function hasAnalyticsConsent(): boolean {
  return hasConsent(ONE_TRUST_GROUPS.ANALYTICS);
}

export function hasTargetingConsent(): boolean {
  return hasConsent(ONE_TRUST_GROUPS.TARGETING);
}

export function subscribeToConsentChanges(callback: () => void): () => void {
  const handler = () => callback();
  window.addEventListener(ONETRUST_CONSENT_CHANGED_EVENT, handler);
  return () =>
    window.removeEventListener(ONETRUST_CONSENT_CHANGED_EVENT, handler);
}
